import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IUsersState } from '../../../../store/users/store';
import { StoreState } from '../../../../store/store';
import { clearUsersError, fetchUsers } from '../../../../store/users/actions';
import UserManagementDataTable from './dataTable/UserManagementDataTable';
import {
  ButtonPrimary,
  IconBadgeAccount,
  IconUser,
  Input,
} from '@skf/bt-wind-rail-commonlibrary';
import style from './UserManagementList.module.scss';
import { useTranslation } from 'react-i18next';
import { ExtendedUser } from '../../../../store/users/types';
import {
  UserManagementAddUsersRoute,
  UserManagementAssignRolesRoute,
  UserManagementModifyUserRoute,
} from '../../../../routes/routes';
import { useLoadingScreen } from '../../../../hooks/useLoadingScreen';
import { usePathname } from '../../../../hooks/usePathname';
import { useAssignUserRoles } from '../../../../hooks/useAssignUserRoles';
import { hasUserRolesOrGrants } from './UserManagementList.mapper';
import { generatePath } from 'react-router';
import { UserManagementDelete } from '../delete/UserManagementDelete';
import { UserManagementRoleDetail } from '../detail/userManagementRoleDetail';
import { UserManagementResetPassword } from '../resetPassword/UserManagementResetPassword';
import { UsersActionTypes } from '../../../../store/users/actionTypes';

interface IUserManagementListProps {}

const UserManagementList: React.FunctionComponent<IUserManagementListProps> = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { setLoading } = useLoadingScreen();
  const { setPathname } = usePathname();
  const { setAssignUserRoles } = useAssignUserRoles();

  const { users }: IUsersState = useSelector<StoreState, IUsersState>(
    (state) => state.users
  );

  const [filteredUsers, setFilteredUsers] = useState<ExtendedUser[]>([]);
  const [selectedUserList, setSelectedUserList] = useState<ExtendedUser[]>([]);

  const [userToDelete, setUserToDelete] = useState<ExtendedUser | undefined>();
  const [userToReset, setUserToReset] = useState<ExtendedUser | undefined>();

  useEffect(() => {
    setFilteredUsers(
      (users || [])?.sort((userA) => (hasUserRolesOrGrants(userA) ? 1 : -1))
    );
    if (users === undefined) {
      dispatch(fetchUsers());
      return;
    }
    setLoading(false);
    dispatch(clearUsersError());
  }, [users]);

  useEffect(() => {
    setAssignUserRoles(selectedUserList);
  }, [selectedUserList]);

  const onSelectUser = (_user: ExtendedUser) => {
    console.log('USER CHECK', _user);

    setSelectedUserList([...selectedUserList, _user]);
  };

  const onSelectDetailUser = (_user: ExtendedUser) => {
    console.log('USER DETAIL', _user);
    setSelectedUserList([_user]);
  };

  const onUnSelectUser = (_user: ExtendedUser) => {
    setSelectedUserList(
      selectedUserList.filter(
        (_userFiltered) =>
          _userFiltered.userName?.toLowerCase() !==
          _user.userName?.toLowerCase()
      )
    );
  };

  const onInputSearch = (text: string) => {
    const _filteredUsers = (users || []).filter(
      (_user) =>
        text.length === 0 ||
        JSON.stringify(_user).toLowerCase().indexOf(text.toLowerCase()) > -1
    );
    setFilteredUsers(_filteredUsers as ExtendedUser[]);
  };

  const onAssignRoles = () => {
    dispatch({ type: UsersActionTypes.CLEAR_USER_ROLE_INFORMATION });
    setPathname(UserManagementAssignRolesRoute.path);
  };

  const onAddUsers = () => {
    setPathname(UserManagementAddUsersRoute.path);
  };

  const onEditUser = (user: ExtendedUser) => {
    setPathname(
      generatePath(UserManagementModifyUserRoute.path, {
        username: user.userName,
      })
    );
  };

  const [displayDetail, _setDisplayDetail] = useState<boolean>(false);
  const [userDetail, _setUserDetail] = useState<ExtendedUser>();
  const onDetailUser = (user: ExtendedUser) => {
    console.log('Detail User:', user);
    _setUserDetail(user);

    //localStorage.setItem('User', JSON.stringify(user));

    //setPathname(generatePath(UserManagementAssignRolesRoute.path, { userName: user.userName }));
    //setSelectedUserList([user]);

    _setDisplayDetail(true);
  };
  const onCloseDetail = () => {
    setSelectedUserList([]);
    _setDisplayDetail(false);
  };

  const onDeleteUser = (user: ExtendedUser) => {
    setUserToDelete(user);
  };

  const onUserManagerDeleteClose = () => {
    setUserToDelete(undefined);
  };

  const onPasswordReset = (user: ExtendedUser) => {
    setUserToReset(user);
  };

  const onUserPasswordResetClose = () => {
    setUserToReset(undefined);
  };

  return (
    <>
      <div className={style.actionRow}>
        <ButtonPrimary
          disabled={selectedUserList.length === 0}
          className={style.actionButton}
          onClick={onAssignRoles}
        >
          <IconBadgeAccount />
          <a>{t('Assign_Roles')}</a>
        </ButtonPrimary>
        <div />
        <ButtonPrimary className={style.actionButton} onClick={onAddUsers}>
          <IconUser />
          <a>{t('Add_Users')}</a>
        </ButtonPrimary>
      </div>
      <Input
        className={style.inputSearch}
        placeholder={`${t('Search')}...`}
        onChange={onInputSearch}
      />
      <UserManagementDataTable
        users={filteredUsers}
        onSelectUser={onSelectUser}
        onUnSelectUser={onUnSelectUser}
        onEditUser={onEditUser}
        onDeleteUser={onDeleteUser}
        onDetailUser={onDetailUser}
        onPasswordReset={onPasswordReset}
      />
      {userToDelete && (
        <UserManagementDelete
          user={userToDelete}
          onClose={onUserManagerDeleteClose}
        />
      )}
      {userToReset && (
        <UserManagementResetPassword
          user={userToReset}
          onClose={onUserPasswordResetClose}
        />
      )}
      {displayDetail ? (
        <UserManagementRoleDetail
          onClose={onCloseDetail}
          userInput={userDetail}
          onSelectDetailUser={onSelectDetailUser}
          onAssignRoles={onAssignRoles}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default UserManagementList;
